
export const getDenominationStyles = () => {
    return denominationRowStyles;
} 

const denominationRowStyles = {
    inputStyle: { width: "100px", textAlign: "right", fontSize: "1.1rem" },
    processingRow: {
        display: "flex",
        gap: "0",
        important: true,
        width: "75%",
    },
    processingRowlgt1: {
        display: "flex",
        gap: "0",
        important: true,
        width: "100%",
        marginTop: "1rem",
    },
    processingRowHeader: {
        textAlign: "right",
        paddingRight: "0.5rem",
        backgroundColor: "inherit",
        height: "30px",
        lineHeight: "30px",
    },
    processingRowAction: {
        textAlign: "right",      
        backgroundColor: "inherit",
        height: "30px",
        lineHeight: "30px",
        marginLeft: '2rem'
    },
    processingRowHeaderCurrency: {
        textAlign: "right",
        fontSize: "1.2rem",
        paddingRight: "2rem",
        fontWeight: "bold",
        width: '3rem'
    },
    processingRowCell: {
        minWidth: "70px",
        maxWidth: "90px",
        important: true,
        backgroundColor: "inherit",
        color: "inherit",
    },
    processingRowCellDisabled: {
        minWidth: "70px",
        maxWidth: "90px",
        important: true,
        color: "inherit",
        textAlign: 'right'
    },
    processingRowCellTotal: {
        important: true,
        minWidth: "60px",
        maxWidth: "160px",
        border: "0px",
        textAlign: "right",
        fontSize: "1.1rem",
        fontWeight: "600",
        backgroundColor: "inherit",
        color: "inherit",
    },
    dummyUkInput: {
        height: "30px",
    },
    rowSeparator: {
        color: "lightgray",
        height: "1px",
        important: true,
        width: "80%",
        marginTop: "1rem",
    },
};